import React, { useEffect, useRef, createRef } from "react";
import { connect } from "react-redux";
import {
    Card as MuiCard,
    CardActionArea,
    CardContent,
    CardMedia,
    Typography
} from "@material-ui/core";
import { styled } from "../../utils/alias";
import { articleForId } from "../../store/reducers";
import { useInView } from "react-intersection-observer";

const Card = styled(MuiCard)`
    && {
        display: flex;
        margin: 6px;
        width: 100%;
    }
`;

const ActionRoot = styled(CardActionArea)`
    && {
        display: flex;
        &:hover {
            text-decoration: none;
            color: inherit;
        }
    }
`;

const TextSection = styled(CardContent)`
    && {
        width: 80%;
    }
`;


const Image = styled(CardMedia)`
    && {
        width: 40%;
        min-width: 200px;
        height: 100%;
    }
`;

const connectReduxToFeedItem = connect((initState, { id }) => state =>
    articleForId(id)(state),
    {
        articleJustSeen: id => ({
            type: "ARTICLE_SEEN",
            id
        })
    }
);

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

let NewsCard = connectReduxToFeedItem(({ articleJustSeen, id, image, description, meta, name, url, isFirst, seen }) => {
    const ref = createRef();
    const [inViewRef, inView] = useInView({ threshold: 0.2, triggerOnce: true });
    useEffect(() => {
        const el = ref.current;
        if (isFirst && el) {
            ref.current.scrollIntoView(true);
            const container = el.parentElement.parentElement.parentElement
            container.scrollTop = container.scrollTop - 10;
        }
    }, []);
    const prevInView = usePrevious(inView);
    useEffect(() => {
        if (!seen && prevInView === false && inView === true) {
            articleJustSeen(id);
        }
    }, [inView])
    return (
        <Card className="article" data-categories={meta.categories} ref={ref}>
            <ActionRoot component="a" href={url} target="_blank" ref={inViewRef}>
                <TextSection>
                    <Typography component="h5" variant="h5">
                        {name}
                    </Typography>
                    <Typography variant="subtitle1" color="textSecondary">
                        {description}
                    </Typography>
                </TextSection>
                <Image component="img" image={image.contentUrl}/>
            </ActionRoot>
        </Card>
    );
});

export { NewsCard };



// WEBPACK FOOTER //
// ./src/components/feed/NewsCard.js